import { render, staticRenderFns } from "./TheQueuesDetails.vue?vue&type=template&id=55c0e70a&scoped=true"
import script from "./TheQueuesDetails.vue?vue&type=script&lang=js"
export * from "./TheQueuesDetails.vue?vue&type=script&lang=js"
import style0 from "./TheQueuesDetails.vue?vue&type=style&index=0&id=55c0e70a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c0e70a",
  null
  
)

export default component.exports